
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 5.058c-1.93 0-3.447 1.567-3.559 3.599-.093 1.692.521 3.186 2.129 4.257.19.127.286.3.332.405.05.113.076.224.09.312.03.177.033.365.026.525a3.704 3.704 0 01-.053.481 1.79 1.79 0 01-.14.468c-.247.492-.657.819-1.073 1.044-.413.225-.884.377-1.324.498-.253.069-.54.138-.808.202-.174.042-.34.081-.482.118-.407.104-.725.204-.957.32-.225.112-.48.385-.733.81-.161.274-.298.57-.408.845h13.925a6.137 6.137 0 00-.404-.839c-.25-.423-.509-.7-.743-.817-.237-.118-.558-.22-.965-.324a35.377 35.377 0 00-.492-.12c-.265-.064-.55-.132-.797-.2-.439-.119-.907-.27-1.32-.494-.414-.225-.823-.551-1.069-1.043-.128-.257-.2-.639-.216-.944-.01-.164-.007-.36.033-.55.032-.157.124-.488.438-.697 1.607-1.071 2.222-2.565 2.129-4.257-.112-2.032-1.63-3.6-3.56-3.6zM6.943 8.574C7.093 5.855 9.171 3.558 12 3.558s4.906 2.297 5.056 5.016c.117 2.11-.658 4.072-2.602 5.456l.002.047a1.707 1.707 0 00.059.347l.005.017c.063.121.19.253.44.389.258.14.593.255.998.365.244.067.47.12.703.176.178.043.362.087.564.138.422.109.875.241 1.264.436.62.31 1.06.883 1.364 1.395.312.53.534 1.092.674 1.502.284.834-.369 1.6-1.163 1.6H4.64c-.798 0-1.45-.772-1.16-1.607a8.48 8.48 0 01.677-1.5c.301-.51.74-1.084 1.354-1.39.384-.193.835-.324 1.255-.431.196-.05.377-.094.553-.136.238-.056.468-.111.714-.178.406-.111.744-.228 1.003-.369.242-.131.37-.258.435-.375a2.203 2.203 0 00.05-.443c-1.926-1.383-2.694-3.338-2.578-5.439z"}})])
          )
        }
      }
    